import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { geSelectPrediction } from "../../redux/actions/pollingAction";
import { BASE_URL_PP } from "../../redux/api";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import loader from "../../assets/loader.gif";

const SelectPredictionComp = ({ handleSelectPrediction }) => {
  const predictionCard = [
    {
      title: "copy best",
      slug: "copy-best",
      description: "Copy best data from:",
      list: ["Pollsters", "Journalist", "Predictors"],
      subText: "anyone who is not a Pollster or Journalist",
    },
    {
      title: "copy averages",
      slug: "copy-averages",
      description: "Copy the average of data from:",
      list: ["Pollsters", "Journalist", "Predictors"],
    },
    {
      title: "copy previous version",
      slug: "copy-previous-version",
      description: "Copy previous version of your own data:",
      list: [
        "Segments:  Gender, Religion , Caste vote shares",
        "Contribution to Vote (by each Segment)",
      ],
    },
    {
      title: "start from scratch",
      slug: "start-from-scratch",
      description: "Start from scratch",
      list: [],
    },
  ];
  const { prediction, setPrediction } = useContext(PredictionContext);
  const dispatch = useDispatch();
  const { SelectPredictionResponse } = useSelector((state) => state?.pollWeb);
  const [istrue, setIstrue] = useState(false)
  const [availablePredictions, setAvailablePredictions] = useState({
    "copy-best": false,
    "copy-averages": false,
    "copy-previous-version": false,
  });
  console.log("🚀 ~ SelectPredictionComp ~ availablePredictions:", availablePredictions)
  const [loading, setLoading] = useState(true);
  const handleBackScreen = () => {
    setPrediction((prev) => ({
      ...prev,
      electionTypeData: {},
      showNext: false,
    }));
  };

  const checkPredictionAvailability = async (slug) => {
    console.log("🚀 ~ checkPredictionAvailability ~ slug:", slug)
    const payload = {
      slug,
      country: prediction?.selectCountry?.id || localStorage.getItem("country"),
      ...(prediction?.electionTypeData?.state !== null && {
        state:
          prediction?.electionTypeData?.state ||
          localStorage.getItem("country"),
      }),
    };

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL_PP}user/poll-analysis/check-prediction`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken") || ""}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 200) {
        const data = await response.json();
        console.log("data", data);
        const hasData = data && data.data;
        setIstrue(data?.data)
        // const hasData = data && (data?.best || data?.average);
        setAvailablePredictions((prev) => ({
          ...prev,
          [slug]: !!hasData,
        }));
         setLoading(false);
      } else {
        setAvailablePredictions((prev) => ({
          ...prev,
          [slug]: false,
        }));
        setLoading(false);
      }
    } catch (error) {
      setAvailablePredictions((prev) => ({
        ...prev,
        [slug]: false,
      }));
    }
  };

  const checkPreviousPredictionAvailability = async () => {
    const payload = {
      country: prediction?.selectCountry?.id || localStorage.getItem("country"),
      ...(prediction?.electionTypeData?.state && {
        state: prediction?.electionTypeData?.state,
      }),
    };

    try {
      const response = await fetch(
        `${BASE_URL_PP}user/user-prediction/previous`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken") || ""
              }`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        const hasData = data?.data?.predictionArray?.length > 0;
        console.log("🚀 ~ checkPredictionAvailability ~ hasData:", hasData)
        // console.log("hasData", hasData);
        setAvailablePredictions((prev) => ({
          ...prev,
          "copy-previous-version": hasData,
        }));

        if (
          !hasData &&
          data?.msg === "No previous predictions found for this country."
        ) {
          console.warn(data?.msg);
        }
      } else {
        setAvailablePredictions((prev) => ({
          ...prev,
          "copy-previous-version": false,
        }));
      }
    } catch (error) {
      console.error("Error checking previous prediction:", error);
      setAvailablePredictions((prev) => ({
        ...prev,
        "copy-previous-version": false,
      }));
    }
  };

  useEffect(() => {
    dispatch(geSelectPrediction());
    checkPredictionAvailability("copy-best");
    checkPredictionAvailability("copy-averages");
    checkPreviousPredictionAvailability();
  }, []);

  return (
    <div>

      <div className="flex flex-col gap-5 py-2 my-7 overflow-y-auto h-auto">
        {!loading ? (
        <div className="my-2 grid grid-cols-1 min-[380px]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
           {predictionCard.map((card, index) => {
            console.log("🚀 ~ SelectPredictionComp ~ card:", card)
            // const isDisabled =
            //   (card.slug === "copy-best" || card.slug === "copy-averages") &&
            //   !availablePredictions[card.slug];

            const isDisabled =
              (card.slug === "copy-best" ||
                card.slug === "copy-averages" ||
                card.slug === "copy-previous-version") &&
              !availablePredictions[card.slug];

            return (
              <div
                key={index}
                className={`${(!istrue && (card.slug === "copy-best" || card.slug === "copy-averages")) ? "hidden" : ""} m-auto w-full min-h-[15rem] flex flex-col transition-all min-[380px]:m-0 
    ${isDisabled
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-white cursor-pointer"
                  } 
    bg-[#F7F8FA] border-2 hover:border-red-500 border-white rounded-xl overflow-hidden hover:shadow-lg duration-300`}
              >

                <div className="p-4 text-center bg-[#4252A8] text-white capitalize">
                  {card.title}
                </div>
                <div className="p-5 flex flex-col flex-grow">
                  <p className="my-2 text-[14px]">{card.description}</p>
                  {card.list?.length > 0 && (
                    <ul className="list-disc mx-5 flex-grow">
                      {card.list.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {card.subText && (
                    <p className="my-1 text-[12px]">{card.subText}</p>
                  )}
                </div>
                <div className="flex justify-center mt-auto mb-3 text-[14px]">
                  {isDisabled === true ? (
                    <div className="px-4 py-2 text-center text-gray-500 bg-gray-300 rounded-xl w-28">
                      Unavailable
                    </div>
                  ) : (
                    <div
                      className={`btn px-4 py-2 text-center rounded-xl w-28 bg-[#E4002B] text-white cursor-pointer
                        `}
                      onClick={() => {
                        handleSelectPrediction(card.title, card.slug);
                      }}
                    >
                      Select
                    </div>


                  )}
                </div>
              </div>
            );
          })}
        </div>
        ) : (
             <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-75">
      <img src={loader} alt="Loading..." className="w-20 h-20" />
    </div>
          )}
      </div>
      <div
        className="btn px-4 py-1 border w-fit rounded-full text-xs cursor-pointer transition-all hover:shadow-sm bg-gray-100 active:scale-95 flex items-center gap-2"
        onClick={() => handleBackScreen()}
      >
        <p className="mb-1">&larr;</p> <p> Go Back Select Election</p>
      </div>
    </div>
  );
};

export default SelectPredictionComp;
